import { ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';

import { Sentry } from '@shared/sentry';
import { Analytics } from '@shared/analytics';
import { vueQueryLib } from '@shared/lib/vue-query-lib';

import { TownFromAPI } from '../api';
import { townFromConfig } from '../config';

export function useTownFromQuery() {
  const isEnabled = ref(false);

  const townFromQuery = useQuery({
    queryKey: ['town-from-query'],
    queryFn: () => TownFromAPI.getTownFrom().then(({ data }) => data),
    staleTime: Infinity, // Static data from admin, so it can't become obsolete during a user session
    enabled: isEnabled,
  });

  vueQueryLib.withOnSuccess({
    query: townFromQuery,
    onSuccess() {
      Analytics.logEvent({ event: townFromConfig.analyticsEvents.SUCCESS });
    },
  });

  vueQueryLib.withOnError({
    query: townFromQuery,
    onError(error) {
      Analytics.logEvent({ event: townFromConfig.analyticsEvents.ERROR });

      Sentry.captureExWithCause('ERR_FAILED_TO_FETCH_TOWNS_FROM', {
        cause: error,
      });
    },
  });

  const init = () => (isEnabled.value = true);

  return { query: townFromQuery, init };
}
